// import React, { useState, useEffect, useRef } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import Card from './Card';
// import Modal from './Modal'; // 모달 컴포넌트 임포트
// import Modal2 from './Modal_2';
// import './CardGroups.css';

// import bookCover from "../../../../asset/bookcover.svg";
// import poster from "../../../../asset/poster.svg";
// import logos from "../../../../asset/logos.svg";
// import promotion from "../../../../asset/promotion.svg";

// import design_1_1 from "../../../../asset/design_1_1.svg";
// import design_1_2 from "../../../../asset/design_1_2.svg";
// import design_1_3 from "../../../../asset/design_1_3.svg";
// import design_1_4 from "../../../../asset/design_1_4.svg";
// import design_1_5 from "../../../../asset/design_1_5.svg";
// import design_1_6 from "../../../../asset/design_1_6.svg";
// import design_1_7 from "../../../../asset/design_1_7.svg";
// import design_1_8 from "../../../../asset/design_1_8.svg";

// import design_2_1 from "../../../../asset/design_2_1.svg";
// import design_2_2 from "../../../../asset/design_2_2.svg";
// import design_2_3 from "../../../../asset/design_2_3.svg";
// import design_2_4 from "../../../../asset/design_2_4.svg";

// import design_3_1 from "../../../../asset/design_3_1.svg";
// import design_3_2 from "../../../../asset/design_3_2.svg";
// import design_3_4 from "../../../../asset/design_3_4.svg";
// import design_3_5 from "../../../../asset/design_3_5.svg";
// import design_3_6 from "../../../../asset/design_3_6.svg";

// import design_4_1 from "../../../../asset/design_4_1.svg";
// import design_4_2 from "../../../../asset/design_4_2.svg";
// import design_4_3 from "../../../../asset/design_4_3.svg";
// import design_4_4 from "../../../../asset/design_4_4.svg";
// import design_4_5 from "../../../../asset/design_4_5.svg";

// import design_5_1 from "../../../../asset/design_5_1.svg";
// import design_5_2 from "../../../../asset/design_5_2.svg";
// import design_5_3 from "../../../../asset/design_5_3.svg";
// import design_5_4 from "../../../../asset/design_5_4.svg";

// const CARD_WIDTH = 150; // 카드의 너비
// const CARD_MARGIN = -150; // 카드 간의 간격

// const groupsData = [
//     {
//         mainImage: design_1_1,
//         cloneImages: [design_1_2, design_1_3, design_1_4, design_1_5, design_1_6, design_1_7, design_1_8],
//         backgroundImage: bookCover
//     },
//     {
//         mainImage: design_2_2,
//         cloneImages: [design_2_1, design_2_3, design_2_4],
//         backgroundImage: promotion
//     },
//     {
//         mainImage: design_5_1,
//         cloneImages: [design_5_2, design_5_3, design_5_4, design_4_5, design_4_1, design_4_2, design_4_3, design_4_4],
//         backgroundImage: logos
//     },
//     {
//         mainImage: design_3_1,
//         cloneImages: [design_3_2, design_3_4, design_3_5, design_3_6],
//         backgroundImage: poster
//     },
// ]

// const CardGroups = () => {
//   const [activeGroup, setActiveGroup] = useState(null); // 현재 활성화된 그룹을 저장하는 상태
//   const [showModal, setShowModal] = useState(false); // 모달 표시 상태
//   const [showSecondModal, setShowSecondModal] = useState(false);
//   const [modalImage, setModalImage] = useState(null); // 모달에 표시할 이미지
//   const [animateBackground, setAnimateBackground] = useState(false); // 배경 이미지 애니메이션 상태
//   const [animationDirection, setAnimationDirection] = useState('in'); // 애니메이션 방향 상태

//   const scrollRefs = useRef([]); // 각 그룹의 스크롤 참조 배열
//   const animationFrameRef = useRef(null); // requestAnimationFrame 참조

//   useEffect(() => {
//     const timer = setTimeout(() => {
//         setShowSecondModal(true);
//     }, 500);

//     console.log(showSecondModal);

//     return () => clearTimeout(timer); // 컴포넌트가 언마운트될 때 타이머 제거
//   }, []);

//   const handleBackgroundClick = (groupIndex) => {
//     setAnimateBackground(true);
//     setAnimationDirection('in'); // 배경이 사라지고 카드가 등장하는 방향 설정
//     setActiveGroup(groupIndex); // 활성화 그룹 설정
//   };

//   const handleCardClick = (image) => {
//     setModalImage(image);
//     setShowModal(true); // 모달 열기
//   };

//   const handleCloseModal = () => {
//     setShowModal(false); // 모달 닫기
//   };

//   const handleCloseSecondModal = () => {
//     setShowSecondModal(false);
//   }

//   useEffect(() => {
//     return () => cancelAnimationFrame(animationFrameRef.current);
//   }, []);

//   // 모든 그룹을 비활성화하고 배경을 원래 위치로 돌리는 함수
//   const resetAllGroups = () => {
//     setAnimationDirection('out'); // 카드들이 사라지고 배경이 등장하는 방향 설정
//     setAnimateBackground(false);
//     setTimeout(() => {
//       setActiveGroup(null); // 모든 그룹 비활성화
//     }, 1000); // 애니메이션이 끝난 후 설정
//   };

//   useEffect(() => {
//     // 페이지의 전체 가로 스크롤을 비활성화
//     document.documentElement.style.overflowX = 'hidden';
//     document.body.style.overflowX = 'hidden';

//     return () => {
//       // 컴포넌트 언마운트 시 가로 스크롤 복원
//       document.documentElement.style.overflowX = 'auto';
//       document.body.style.overflowX = 'auto';
//     };
//   }, []);

//   return (
//       <div className="card-groups-container">
//         {groupsData.map((group, index) => (
//           <div className="card-groups" key={index}>
//             {/* 배경 이미지 클릭 시 애니메이션 */}
//             <motion.div
//               className="background-wrapper"
//               animate={{
//                 x: animateBackground && activeGroup === index ? '-100%' : '0%',
//                 opacity: animationDirection === 'in' ? 1 : 0.5 // 사라질 때 약간의 투명도 변화
//               }} // 배경 이미지 왼쪽으로 사라짐
//               transition={{ duration: 1 }} // 애니메이션 시간
//               onClick={() => handleBackgroundClick(index)} // 배경 이미지 클릭 시
//             >
//               <img
//                 src={group.backgroundImage}
//                 alt="Background"
//                 className="background-image"
//               />
//             </motion.div>

//             {/* 메인 카드와 클론 카드 애니메이션 */}
//             <motion.div
//               className="scroll-container"
//               initial={{ x: '100%' }}
//               animate={{
//                 x: activeGroup === index && animateBackground ? '0%' : '100%', // 배경이 사라질 때 동시에 카드 등장
//                 opacity: animationDirection === 'in' ? 1 : 0,
//                 overflowX: activeGroup === index ? 'auto' : 'hidden' // 배경 클릭 전까지는 스크롤 불가
//               }} // 오른쪽에서부터 등장
//               transition={{ duration: 1 }} // 배경 이미지와 동시에 등장
//               ref={(el) => (scrollRefs.current[index] = el)} // 각 그룹의 스크롤 컨테이너에 ref 할당
//             >
//               {/* 메인 카드 */}
//               <div className="main-card-wrapper">
//                 <Card
//                   className="main-card"
//                   image={group.mainImage}
//                   onClick={() => handleCardClick(group.mainImage)} // 메인 카드 클릭 시 모달 표시
//                 />
//               </div>

//               {/* 클론 카드들 */}
//               <div className="clones-container">
//                 <AnimatePresence>
//                   {activeGroup === index && group.cloneImages && group.cloneImages.length > 0 && (
//                     group.cloneImages.map((img, i) => (
//                       <motion.div
//                         key={i}
//                         className="clone-card-wrapper"
//                         initial={{ x: 0, opacity: 0 }}
//                         animate={{
//                           x: (i + 1) * (CARD_WIDTH + CARD_MARGIN),
//                           opacity: 1,
//                         }}
//                         transition={{
//                           delay: i * 0.2,
//                           type: 'tween',
//                           duration: 0.8,
//                         }}
//                         style={{ zIndex: group.cloneImages.length - i }}
//                         onClick={() => handleCardClick(img)} // 클론 카드 클릭 시 모달 표시
//                       >
//                         <Card
//                           className="clone-card"
//                           image={img}
//                         />
//                       </motion.div>
//                     ))
//                   )}
//                 </AnimatePresence>
//               </div>
//             </motion.div>
//           </div>
//         ))}

//         {/* 리셋 버튼 */}
//         {/* {activeGroup !== null && (
//           <button className="reset-button" onClick={resetAllGroups}>
//             Reset
//           </button>
//         )} */}

//         {/* 모달 컴포넌트 */}
//         {showSecondModal && (
//           <Modal2 onClose={handleCloseSecondModal} />
//         )}

//         {showModal && (
//           <Modal image={modalImage} onClose={handleCloseModal} />
//         )} 
//       </div>
//   );
// };

// export default CardGroups;

import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Card from './Card';
import Modal from './Modal'; // 모달 컴포넌트 임포트
import Modal2 from './Modal_2';
import './CardGroups.css';

import bookCover from "../../../../asset/bookcover.svg";
import poster from "../../../../asset/poster.svg";
import logos from "../../../../asset/logos.svg";
import promotion from "../../../../asset/promotion.svg";

import design_1_1 from "../../../../asset/design_1_1.png";
import design_1_2 from "../../../../asset/design_1_2.png";
import design_1_3 from "../../../../asset/design_1_3.png";
import design_1_4 from "../../../../asset/design_1_4.png";
import design_1_5 from "../../../../asset/design_1_5.png";
import design_1_6 from "../../../../asset/design_1_6.png";
import design_1_7 from "../../../../asset/design_1_7.png";
import design_1_8 from "../../../../asset/design_1_8.png";

import design_2_1 from "../../../../asset/design_2_1.png";
import design_2_2 from "../../../../asset/design_2_2.png";
import design_2_3 from "../../../../asset/design_2_3.svg";
import design_2_4 from "../../../../asset/design_2_4.png";

import design_3_1 from "../../../../asset/design_3_1.png";
import design_3_2 from "../../../../asset/design_3_2.png";
import design_3_4 from "../../../../asset/design_3_4.png";
import design_3_5 from "../../../../asset/design_3_5.png";
import design_3_6 from "../../../../asset/design_3_6.png";

import design_4_1 from "../../../../asset/design_4_1.png";
import design_4_2 from "../../../../asset/design_4_2.png";
import design_4_3 from "../../../../asset/design_4_3.png";
import design_4_4 from "../../../../asset/design_4_4.png";
import design_4_5 from "../../../../asset/design_4_5.png";

import design_5_1 from "../../../../asset/design_5_1.png";
import design_5_2 from "../../../../asset/design_5_2.png";
import design_5_3 from "../../../../asset/design_5_3.png";
import design_5_4 from "../../../../asset/design_5_4.png";

const CARD_WIDTH = 150; // 카드의 너비
const CARD_MARGIN = -150; // 카드 간의 간격

const groupsData = [
    {
        mainImage: design_1_1,
        cloneImages: [design_1_2, design_1_3, design_1_4, design_1_5, design_1_6, design_1_7, design_1_8],
        backgroundImage: bookCover
    },
    {
        mainImage: design_2_2,
        cloneImages: [design_2_1, design_2_3, design_2_4],
        backgroundImage: promotion
    },
    {
        mainImage: design_5_1,
        cloneImages: [design_5_2, design_5_3, design_5_4, design_4_5, design_4_1, design_4_2, design_4_3, design_4_4],
        backgroundImage: logos
    },
    {
        mainImage: design_3_1,
        cloneImages: [design_3_2, design_3_4, design_3_5, design_3_6],
        backgroundImage: poster
    },
]

const CardGroups = () => {
  const [activeGroup, setActiveGroup] = useState(null); // 현재 활성화된 그룹을 저장하는 상태
  const [showModal, setShowModal] = useState(false); // 모달 표시 상태
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [modalImage, setModalImage] = useState(null); // 모달에 표시할 이미지
  const [animateBackground, setAnimateBackground] = useState(false); // 배경 이미지 애니메이션 상태
  const [animationDirection, setAnimationDirection] = useState('in'); // 애니메이션 방향 상태

  const [dragStartX, setDragStartX] = useState(null); // 드래그 시작 위치
  const scrollRefs = useRef([]); // 각 그룹의 스크롤 참조 배열
  const animationFrameRef = useRef(null); // requestAnimationFrame 참조

  useEffect(() => {
    const timer = setTimeout(() => {
        setShowSecondModal(true);
    }, 500);

    return () => clearTimeout(timer); // 컴포넌트가 언마운트될 때 타이머 제거
  }, []);

  const handleBackgroundClick = (groupIndex) => {
    setAnimateBackground(true);
    setAnimationDirection('in'); // 배경이 사라지고 카드가 등장하는 방향 설정
    setActiveGroup(groupIndex); // 활성화 그룹 설정
  };

  const handleCardClick = (image) => {
    setModalImage(image);
    setShowModal(true); // 모달 열기
  };

  const handleMouseDown = (e) => {
    setDragStartX(e.clientX); // 드래그 시작 위치 저장
  };

  const handleMouseMove = (e, groupIndex) => {
    if (dragStartX !== null) {
      const dragDistance = e.clientX - dragStartX; // 드래그 거리 계산
      if (dragDistance < -50) {
        // 왼쪽으로 50px 이상 드래그 시 클릭 효과 발생
        handleBackgroundClick(groupIndex);
        setDragStartX(null); // 드래그 시작 위치 초기화
      }
    }
  };

  const handleMouseUp = () => {
    setDragStartX(null); // 마우스를 떼면 드래그 상태 초기화
  };

  const handleDragStart = (e) => {
    e.preventDefault(); // 기본 드래그 이벤트 방지
  };

  const handleCloseModal = () => {
    setShowModal(false); // 모달 닫기
  };

  const handleCloseSecondModal = () => {
    setShowSecondModal(false);
  }

  useEffect(() => {
    const currentAnimationFrame = animationFrameRef.current;
    return () => cancelAnimationFrame(currentAnimationFrame);
}, []);

  // 모든 그룹을 비활성화하고 배경을 원래 위치로 돌리는 함수
  // const resetAllGroups = () => {
  //   setAnimationDirection('out'); // 카드들이 사라지고 배경이 등장하는 방향 설정
  //   setAnimateBackground(false);
  //   setTimeout(() => {
  //     setActiveGroup(null); // 모든 그룹 비활성화
  //   }, 1000); // 애니메이션이 끝난 후 설정
  // };

  useEffect(() => {
    // 페이지의 전체 가로 스크롤을 비활성화
    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';

    return () => {
      // 컴포넌트 언마운트 시 가로 스크롤 복원
      document.documentElement.style.overflowX = 'auto';
      document.body.style.overflowX = 'auto';
    };
  }, []);

  return (
    <div className="card-groups-container" onMouseUp={handleMouseUp}>
      {groupsData.map((group, index) => (
        <div
          className="card-groups"
          key={index}
          onMouseDown={(e) => handleMouseDown(e)}
          onMouseMove={(e) => handleMouseMove(e, index)}
        >
          {/* 배경 이미지 클릭 시 애니메이션 */}
          <motion.div
            className="background-wrapper"
            animate={{
              x: animateBackground && activeGroup === index ? '-100%' : '0%',
              opacity: animationDirection === 'in' ? 1 : 0.5 // 사라질 때 약간의 투명도 변화
            }} // 배경 이미지 왼쪽으로 사라짐
            transition={{ duration: 1 }} // 애니메이션 시간
            onClick={() => handleBackgroundClick(index)} // 배경 이미지 클릭 시
          >
            <img
              src={group.backgroundImage}
              alt="Background"
              className="background-image"
              draggable="false"
              onDragStart={handleDragStart}
            />
          </motion.div>

          {/* 메인 카드와 클론 카드 애니메이션 */}
          <motion.div
            className="scroll-container"
            initial={{ x: '100%' }}
            animate={{
              x: activeGroup === index && animateBackground ? '0%' : '100%', // 배경이 사라질 때 동시에 카드 등장
              opacity: animationDirection === 'in' ? 1 : 0,
              overflowX: activeGroup === index ? 'auto' : 'hidden' // 배경 클릭 전까지는 스크롤 불가
            }} // 오른쪽에서부터 등장
            transition={{ duration: 1 }} // 배경 이미지와 동시에 등장
            ref={(el) => (scrollRefs.current[index] = el)} // 각 그룹의 스크롤 컨테이너에 ref 할당
          >
            {/* 메인 카드 */}
            <div className="main-card-wrapper">
              <Card
                className="main-card"
                image={group.mainImage}
                onClick={() => handleCardClick(group.mainImage)} // 메인 카드 클릭 시 모달 표시
              />
            </div>

            {/* 클론 카드들 */}
            <div className="clones-container">
              <AnimatePresence>
                {activeGroup === index && group.cloneImages && group.cloneImages.length > 0 && (
                  group.cloneImages.map((img, i) => (
                    <motion.div
                      key={i}
                      className="clone-card-wrapper"
                      initial={{ x: 0, opacity: 0 }}
                      animate={{
                        x: (i + 1) * (CARD_WIDTH + CARD_MARGIN),
                        opacity: 1,
                      }}
                      transition={{
                        delay: i * 0.2,
                        type: 'tween',
                        duration: 0.8,
                      }}
                      style={{ zIndex: group.cloneImages.length - i }}
                      onClick={() => handleCardClick(img)} // 클론 카드 클릭 시 모달 표시
                    >
                      <Card
                        className="clone-card"
                        image={img}
                      />
                    </motion.div>
                  ))
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        </div>
      ))}

      {/* 모달 컴포넌트 */}
      {showSecondModal && (
        <Modal2 onClose={handleCloseSecondModal} />
      )}
      
      {showModal && (
        <Modal image={modalImage} onClose={handleCloseModal} />
      )} 
    </div>
  );
};

export default CardGroups;